import React from 'react';
import { Grid } from '@material-ui/core';

import { useSelector } from 'react-redux';
import yup from '../../../utility/yup';
import { Loadable } from '../../../store/types';
import { Project } from '../../../types/items';
import {
  ItemForm,
  FormInput,
  FieldOrganizationSelect, FormSwitch,
} from '../../../components/index';
import OrganizationField from '../tab-overview/fields/OrganizationField';
import OwnerUserField from '../tab-overview/fields/OwnerUserField';
import { selectIsAdmin } from '../../../store/modules/users/selectors';


const projectSchema = yup.object().shape({

});

type Props = {
  creatingMode?: boolean;
  record: Loadable<Project>;
  onSubmit: (record: Project) => void;
  isSuperAdmin?: boolean;
};

const ProjectForm = ({
  creatingMode = false,
  record: { loading, data },
  onSubmit,
  isSuperAdmin = false,
}: Props) => {
  const isAdmin = useSelector(selectIsAdmin);

  return (
    <>
      <ItemForm
        creatingMode={creatingMode}
        initialValues={data}
        validationSchema={projectSchema}
        onSubmit={onSubmit}
        loading={loading}
        editPermitted={Boolean(data?.permissions.can_edit)}
        enableReinitialize
      >
        <Grid container spacing={4}>
          <Grid item xs={6}>
            <FormInput
              label="Created"
              name="ref.created_age"
              disabled
            />
          </Grid>
          <Grid item xs={6}>
            <FormInput
              label="Last edit"
              name="ref.updated_age"
              disabled
            />
          </Grid>
          { !data?.ref.organization && !loading
          && (
            <>
              <Grid item xs={6}>
                {isSuperAdmin
                  ? <FieldOrganizationSelect name={data?.ref.organization?.common_name || ''} />
                  : <OrganizationField project={data} />}
              </Grid>
              <Grid item xs={6}>
                <OwnerUserField
                  project={data}
                />
              </Grid>
            </>
          )}
          <Grid item xs={12}>
            <FormSwitch
              label="Billing Completed"
              name="is_billing_completed"
              disabled={!isAdmin}
            />
          </Grid>
        </Grid>
      </ItemForm>
    </>
  );
};

export default ProjectForm;
